import { CaretLeft } from '@phosphor-icons/react';
import { kontaktTabPfad, type KontaktTab } from '../../../lib/kontakte/detailTab';
import { avatarFarbe, kontaktInitialen } from '../../../lib/kontakte/sonstige';
import type { KontaktAnzahl, SonstigerKontaktZustand } from '../../../lib/kontakte/useSonstigerKontakt';
import { KONTAKT_TAB_META, tabZaehler } from '../kontaktTabs';
import { SidebarDock } from './SidebarDock';

/**
 * Kontext-Sidebar eines sonstigen Kontakts (Handoff Sonstige Kontakte §2, Screens 05–08):
 * „Alle Kontakte“, Kontaktkarte, Navigation Übersicht/Verknüpft/Aktivität/Notizen mit Zählern.
 */
export function KontaktModus({ kontaktId, zustand, anzahl, tab, onNavigate }: {
  kontaktId: string;
  zustand: SonstigerKontaktZustand;
  anzahl: KontaktAnzahl | null;
  tab: KontaktTab;
  onNavigate: (pfad: string) => void;
}) {
  const name = zustand.status === 'ok' ? zustand.kopf.anzeigename : '';
  const f = avatarFarbe(kontaktId);

  return (
    <div className="sk-flaeche sk-side-in flex min-h-0 flex-1 flex-col" style={{ gap: 12, background: 'transparent', minHeight: 0 }}>
      <button
        type="button"
        onClick={() => onNavigate('/admin/kontakte')}
        data-tip="Zurück – Zur Liste der sonstigen Kontakte"
        className="sk-nav flex cursor-pointer items-center self-start"
        style={{ height: 30, padding: '0 12px 0 8px', borderRadius: 15, border: 'none', gap: 5, background: 'var(--fill2)', fontSize: 12, fontWeight: 700, color: 'var(--ink)' }}
      >
        <CaretLeft weight="bold" size={12} />
        Alle Kontakte
      </button>

      <button
        type="button"
        onClick={() => onNavigate(kontaktTabPfad(kontaktId, 'uebersicht'))}
        aria-label={name ? `${name} – Übersicht` : 'Kontakt-Übersicht'}
        className="flex cursor-pointer items-center text-left"
        style={{ borderRadius: 18, border: 'none', padding: '14px 12px', gap: 10, color: 'var(--ink)', background: 'var(--fill)', boxShadow: 'inset 0 0 0 1px var(--line)' }}
      >
        <span aria-hidden className="flex shrink-0 items-center justify-center"
          style={{ width: 42, height: 42, borderRadius: '50%', fontSize: 14, fontWeight: 800, color: 'var(--sk-av-ink)', background: f.verlauf, boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4)' }}>
          {name ? kontaktInitialen(name) : ''}
        </span>
        <span className="flex min-w-0 flex-col" style={{ gap: 1 }}>
          {zustand.status === 'laedt' && <span style={{ fontSize: 13, color: 'var(--ink3)' }}>Lädt …</span>}
          {zustand.status === 'fehler' && <span style={{ fontSize: 12, color: 'var(--bad)' }}>Kontakt konnte nicht geladen werden.</span>}
          {zustand.status === 'fehlt' && <span style={{ fontSize: 12, color: 'var(--ink3)' }}>Kontakt nicht gefunden.</span>}
          {name && (
            <>
              <span className="truncate" style={{ fontSize: 14, fontWeight: 800 }}>{name}</span>
              <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>Sonstiger Kontakt</span>
            </>
          )}
        </span>
      </button>

      <nav aria-label="Kontaktnavigation" className="immo-ohne-scrollbar flex min-h-0 flex-1 flex-col overflow-auto" style={{ gap: 2 }}>
        {KONTAKT_TAB_META.map(t => {
          const an = t.key === tab;
          const I = t.icon;
          return (
            <button
              key={t.key}
              type="button"
              aria-current={an ? 'page' : undefined}
              data-tip={t.tip}
              onClick={() => onNavigate(kontaktTabPfad(kontaktId, t.key))}
              className="sk-nav flex w-full cursor-pointer items-center text-left"
              style={{ gap: 10, padding: '8px 9px', borderRadius: 11, border: 'none', fontSize: 13, fontWeight: an ? 800 : 600, color: 'var(--ink)', background: an ? 'var(--sk-hover)' : 'transparent' }}
            >
              <span aria-hidden className="flex shrink-0 items-center justify-center"
                style={{ width: 26, height: 26, borderRadius: 8, color: an ? 'var(--sk-av-ink)' : 'var(--ink2)', background: an ? `linear-gradient(155deg, var(--sk-av-${t.farbe}-a), var(--sk-av-${t.farbe}-b))` : 'var(--fill2)' }}>
                <I weight="fill" size={15} />
              </span>
              <span className="flex-1">{t.label}</span>
              <span className="immo-zahl" style={{ fontSize: 11, fontWeight: 700, color: 'var(--ink3)' }}>{tabZaehler(t, anzahl)}</span>
            </button>
          );
        })}
      </nav>

      <SidebarDock aktiv="kontakte" onNavigate={onNavigate} />
    </div>
  );
}
